import { useCreateFbAccMutation } from "../../services";
import { IFacebookBotInput } from "../types";

interface IProps {
    projectId: string | undefined;
    characterId: string | undefined;
}
const useFbMutation = ({ projectId, characterId }: IProps) => {
    const [createFbAcc, { isLoading: createLoading, isSuccess: createSuccess }] = useCreateFbAccMutation();

    const handleCreate = async (data: IFacebookBotInput) => {
        if (projectId && characterId) {
            const reqData = {
                ...data,
                project_id: projectId,
                character_id: characterId,
            };
            await createFbAcc(reqData);
        }
    };

    return { handleCreate, createLoading, createSuccess };
};
export default useFbMutation;
